<template>
  <div class="promote">
    <el-scrollbar style="height:95vh">
      <div class="left">
        <UploadPic ref="BigPic" :width="500" :height="'auto'" @upLoadImage="bigupLoadImage" />
        <!-- <el-image :src="bigPic"></el-image> -->
        <div class="float">
          <el-form :model="bigform" class="promote_form" label-width="80px" size="mini">
            <div style="display: flex; margin-bottom: 10px">
              <el-image
                :src="logo"
                style="width: 55px; height: 55px; margin-right: 20px"
              />
              <div>
                <div style="font-size: 20px">木瓜APP</div>
                <span>高颜值的真人认证交友平台</span>
              </div>
            </div>
            <el-form-item label="她的名字：">
              <el-input v-model="bigform.name" size="mini" type="text" placeholder="点击填写名字" />
            </el-form-item>
            <el-form-item label="来自：">
              <el-input v-model="bigform.from" size="mini" type="text" placeholder="点击填写来自" />
            </el-form-item>
            <el-form-item label="联系方式：">
              <el-input v-model="bigform.phone" size="mini" autosize type="textarea" placeholder="点击填写联系方式" />
            </el-form-item>
            <div @click="dialogVisible=true">
              登录
              <span style="font-size: 20px; font-weight: 600; color: #f1cea4">{{
                location
              }}</span>下载APP,查看更多颜值女神

            </div>
          </el-form>
        </div>
      </div>
      <div class="right" style="width:450px;height:812px">
        <el-image :src="top" style="width:450px" />
        <div class="item">
          <div class="item_left">
            <UploadPic ref="avator" :round="true" :width="60" :height="60" @upLoadImage="avatorupLoadImage" />
            <div style="margin-left:20px" @click="userVisible=true">
              <div style="font-size:16px;font-weight:600;margin-bottom:5px;color:#545454">{{ user.name }}</div>
              <label class="tag">{{ user.tag }}</label>
              <div style="margin-top:8px">
                <i class="iconfont icon-daohang" />
                <el-tag type="info" size="mini">{{ user.location }}</el-tag>
              </div>
            </div>
            <div class="time">{{ user.min }}</div>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <el-dialog
      title="更换网站"
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
    >
      <el-input v-model="location" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary" class="edit-button"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更换网站"
      :visible.sync="userVisible"
      width="30%"
      append-to-body
    >
      <el-form v-model="user" label-width="80px">
        <el-form-item label="名字:">
          <el-input v-model="user.name" type="text" />
        </el-form-item>
        <el-form-item label="标签地点:">
          <el-input v-model="user.tag" type="text" />
        </el-form-item>
        <el-form-item label="定位地点:">
          <el-input v-model="user.location" type="text" />
        </el-form-item>
        <el-form-item label="时间:">
          <el-input v-model="user.min" type="text" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userVisible = false">取 消</el-button>
        <el-button
          type="primary" class="edit-button"
          @click="userVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import UploadPic from '@/components/Upload/UploadPic'
export default {
  components: {
    UploadPic
  },
  data() {
    return {
      bigPic: require('@/assets/image/test.jpg'),
      logo: require('@/assets/image/logo.png'),
      bigform: {},
      location: 'ggyit.com',
      dialogVisible: false,
      top: require('@/assets/image/top.jpg'),
      avator: require('@/assets/image/logo.png'),
      user: {
        avator: require('@/assets/image/logo.png'),
        name: '安小熙',
        tag: '广州市',
        location: '广州市',
        min: '5分钟'
      },
      userVisible: false
    }
  },
  mounted() {
    this.$refs.BigPic.init(this.bigPic)
    this.$refs.avator.init(this.user.avator)
  },
  methods: {
    // 上传图片回调函数
    bigupLoadImage(e) {
      this.bigPic = e
    },
    avatorupLoadImage(e) {
      this.user.avator = e
    }
  }
}
</script>
<style lang="scss" scoped>
.promote {
  color: #ffffff;
  font-family: PingFangSC-Regular, sans-serif;
  margin-left: 250px;
}
.left {
  position: relative;

  .float {
    position: absolute;
    left: 20px;
    bottom: 10px;
    // width: 450px;
    // height: 225px;
    background-color: rgba(1, 1, 1, 0.3);
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .promote_form::v-deep {
      .el-form-item__label {
        color: #ffffff;
        padding-right: 0;
      }
      .el-input__inner{
          padding-left: 0;
          font-size: 14px;
      }
      .el-form-item {
        margin-bottom: 0;
      }
      input {
        background-color: rgba(0, 0, 0, 0);
        outline: none;
        border: none;
        color: #ffffff;
      }
      textarea{
        background-color: rgba(0, 0, 0, 0);
        outline: none;
        border: none;
        color: #ffffff;
        padding-left: 0;
        font-size: 14px;
        overflow-y: hidden;//解决在微信下滚动条还是显示问题
        padding-right: 0;
      }
      textarea::-webkit-input-placeholder{
        color: #ffffff;
      }
      input::-webkit-input-placeholder {
        color: #ffffff;
      }
    }
  }
}
.right{
    .item::v-deep{
        padding: 0 20px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: space-between;
         position: relative;
         .avatar-uploader {
             margin: 0;
         }
        .item_left{
            display: flex;

            .tag{
                margin: 6px 0;
                font-size: 12px;
                border-radius: 23px;
                padding: 1px 5px;
                width: 100%;
                box-sizing: border-box;
                border: solid 1px #c3c3c3;
                color: #565656;
                text-align: center;
            }
            .time{
                position: absolute;
                color:  #a9a9a9;
                right: 15px;
            }
        }
    }
}
</style>
